import React from 'react';
import { Link } from 'react-router-dom';
import { MODULES } from '../data/modules';

export default function SiteFooter() {
  const liveModules = MODULES.filter((m) => m.status === 'Live').slice(0, 6);
  const comingModules = MODULES.filter((m) => m.status !== 'Live').slice(0, 6);

  return (
    <footer className="bg-surface1 border-t border-border text-textSecondary py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-textPrimary font-display font-bold text-xl mb-3">Bankably</h3>
            <p className="text-sm">Gold-backed financial operating system, built on the Aureus Protocol.</p>
          </div>
          <div>
            <h4 className="text-textPrimary font-semibold mb-3">Live Modules</h4>
            <ul className="space-y-2 text-sm">
              {liveModules.map((m) => (
                <li key={m.slug}><Link to={`/modules/${m.slug}`} className="hover:text-gold transition">{m.shortName}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-textPrimary font-semibold mb-3">Coming Soon</h4>
            <ul className="space-y-2 text-sm">
              {comingModules.map((m) => (
                <li key={m.slug}><Link to={`/modules/${m.slug}`} className="hover:text-gold transition">{m.shortName}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-textPrimary font-semibold mb-3">Account</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/wishlist" className="hover:text-gold transition">Join Waitlist</Link></li>
              <li><Link to="/login" className="hover:text-gold transition">Sign In</Link></li>
              <li><Link to="/proof-layer" className="hover:text-gold transition">The Proof Layer</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-gold transition">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="hover:text-gold transition">Terms of Service</Link></li>
              <li><a href="mailto:hello@bankably.co" className="hover:text-gold transition">hello@bankably.co</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-border text-sm">
          © 2026 Bankably Inc. Gold-backed financial services powered by the Aureus Protocol.
        </div>
      </div>
    </footer>
  );
}
